import GiftCardSettings from './GiftCardSettings';
export default GiftCardSettings;
